import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import useIsTestEnv from '@shared/hooks/useIsTestEnv'

const useToggleLocalization = () => {
  const isTestEnv = useIsTestEnv()

  const [isToggled, setIsToggled] = useState(true)

  const { t, i18n } = useTranslation()

  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (!isTestEnv) {
        return
      }

      const isWindows = navigator.platform.includes('Win')
      const isMac = navigator.platform.includes('Mac')

      const isCtrlKey = (isWindows && event.ctrlKey) || (isMac && event.metaKey)
      const isAltKey = event.altKey
      const isShiftKey = event.shiftKey

      if (isCtrlKey && isAltKey && isShiftKey && event.code === 'KeyL') {
        i18n.changeLanguage(!isToggled ? 'en' : 'cimode')
        setIsToggled(!isToggled)
      }
    },
    [isToggled, i18n, isTestEnv],
  )

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress)

    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [handleKeyPress])

  return t
}

export default useToggleLocalization
